import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import {
  getValidToken,
  isApp,
  resolveLocalizedText,
  resolvePublicAssets,
} from '../../../../utils';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';

export interface ServiceSectionProps {
  onClickModuleCard: (cardId: string) => void;
  context: {
    desc: string;
    services: Array<{
      icon: string;
      title: string;
      desc: string;
      value: Array<string>;
    }>;
  };
}

export class ServiceSection extends Component<ServiceSectionProps> {
  constructor(props: any = {}) {
    super(props);
    this.onClickToGatc = this.onClickToGatc.bind(this);
  }

  onClickToGatc(item: any) {
    const serviceOverlay = item ? item.title : '';
    const tcWindow: any = window;
    try {
      const token = select(getToken);
      const aToken = getValidToken(token);
      tcWindow.dataLayer.push({
        event: 'Critical Illness Value-Added-Services',
        serviceOverlay: serviceOverlay,
        screenName: getGaPagePath(),
        userId: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.criticalIllness(this, {
      //     serviceOverlay: serviceOverlay,
      //     screenName: getGaPagePath(),
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  render() {
    const { context, onClickModuleCard } = this.props;

    return (
      <div className="my-privileges-details-view__form_wrap">
        {context.desc && (
          <div
            className="my-privileges-details-view__introduce-desc"
            dangerouslySetInnerHTML={{ __html: memoSanitize(context.desc) }}
          ></div>
        )}
        <div className="my-privileges-details-view__disease_slider_wrap">
          {context.services.map((service: any, index: number) => {
            return (
              <div
                className="my-privileges-details-view__disease_slider_wrap_item"
                key={index}
                data-enable-ga
                data-ga-type="button"
                onClick={() => {
                  this.onClickToGatc(service);
                  onClickModuleCard(service.id);
                }}
              >
                <div className="my-privileges-details-view__disease_slider_wrap_item_card_view_container">
                  <div className="my-privileges-details-view__disease_slider_wrap_item_card_view">
                    <div>
                      <img
                        src={
                          service.icon
                            ? resolvePublicAssets(
                                resolveLocalizedText(service.icon),
                              ).replace('.png', '@3x.png')
                            : ''
                        }
                        alt=""
                      />
                    </div>
                    <div>{service.title}</div>
                    <div>{service.desc}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="divider" />
      </div>
    );
  }
}
